
export default {
  props:{
    region:{
      type:String,
      default:'UK',
    },
  },
}
